import Keycloak from "keycloak-js/dist/keycloak.js";

const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;

const keycloakData = {
    realm: "streetscooter",
    url: keycloakUrl,
    clientId: "usermanagement"
};

export const keycloak = new Keycloak(keycloakData);
